import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import Footer from 'components/Footer';
import { rem } from 'polished';
import { COLOR, SPACE } from 'config';

import Hero from './components/Hero';
import Content from './components/Content';
import InstallWallet from './components/InstallWallet';
import JoinNow from './components/JoinNow';
import Presentation from './components/Presentation';
import FreeDrink from './components/FreeDrink';
import headerBackground from './images/header.png';

const LandingContainer = styled.div`
  background-color: ${COLOR.lightGrey};
`;

const NYCMeetUpLanding = ({ intl }) => (
  <LandingContainer>
    <Helmet>
      <meta
        name="description"
        content={intl.formatMessage({ id: 'landing.skycoin.description' })}
      />
    </Helmet>
    <Hero
      title=""
      description="Internet from the future is touching down in NYC"
      description2="Skycoin is an established and revolutionary crypto-ecosystem supporting a truly private,
      secure, and distributed Internet called Skywire. Designed by early Bitcoin and Ethereum
      developers, Skycoin provides an all encompassing solution to the shortfalls of early
      cryptocurrencies. NYC has been chosen to be the testing ground for Skywire, the new
      Internet."
      buttonText="Learn about Skycoin"
      to="https://skycoin.com/"
      buttonText2="Learn about Skywire"
      to2="https://skycoin.com/skywire"
      banner={headerBackground}
    />
    <Content mb={rem(SPACE[3])} mx="auto" notHero>
      <JoinNow />
      <FreeDrink />
      <Presentation />
      <InstallWallet />
    </Content>
    <Footer />
  </LandingContainer>
);

NYCMeetUpLanding.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(NYCMeetUpLanding);



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/NYCMeetUpLanding.js